module.exports = __webpack_public_path__ + "./docs/img/icon-js.09b6136b04a178d2ce8b98b4403413ee.svg";